import ordersService from '@/services/orders.service'


export default {
  // 📋 Fetch orders list
  async fetchOrders({ commit, state }, payload = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const filters = { ...state.filters, ...payload }
      commit('SET_FILTERS', filters)

      const res = await ordersService.getOrders(filters)
      commit('SET_ORDERS', res)
      commit('SET_PAGINATION', res.meta)

      return res
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch orders')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 👤 Get single order
    async fetchOrder({ commit }, id) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const order = await ordersService.getOrder(id)
        commit('SET_ORDER', order)
        return order
      } catch (err) {
        commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch order')
      } finally {
        commit('SET_LOADING', false)
      }
    },



    // ➕ create order

    async placeOrder({ commit }, data) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_MESSAGE', null)
      commit('SET_ORDER_ERROR_MESSAGE',null)
      try {
        const order = await ordersService.placeOrder(data)
        commit('SET_MESSAGE', order.message || 'Order placed successfully')
        return order
      } catch (err) {
        commit('SET_ERROR', {
          status: err?.data?.status,
          message: err?.data?.message || 'Something went wrong',
          errors: err?.data?.errors || {}
        })
        commit('SET_ORDER_ERROR_MESSAGE', err.response?.data?.message || 'Failed to place order')
        throw err // 🔥 important if component needs it
        
      } finally {
        commit('SET_LOADING', false)
      }
    },
    

    // ➕ create order
   async placeOrderTrial({ commit }, data) {
      commit('SET_ERROR', null)
      try {
        const { data: order } =
        await ordersService.placeOrderTrial(data)
        return order
      } catch (err) {
        commit('SET_ERROR', {
          status: err?.data?.status,
          message: err?.data?.message || 'Something went wrong',
          errors: err?.data?.errors || {}
        })
        
        throw err // 🔥 important if component needs it
      
      } 
    },

  
    async clearMessage({ commit }) {
      commit('SET_MESSAGE', null)
      commit('SET_ERROR', null)
    },
   

    async setError({ commit }, data) {
      commit('SET_ERROR', data)
    },

    async checkReference({ commit }, reference) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_MESSAGE', null)
      try {
        const res = await ordersService.checkReference(reference)
        return res
      } catch (err) {
        commit('SET_ERROR', err.response?.data?.message || 'Failed to check reference')
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async printInvoice({ commit }, orderId) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_MESSAGE', null)
      try {
        const res = await ordersService.printInvoice(orderId)
        return res
      } catch (err) {
        commit('SET_ERROR', err.response?.data?.message || 'Failed to print invoice')
      } finally {
        commit('SET_LOADING', false)
      }
    },


    async submitPayment({ commit }, {orderId, data}) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_MESSAGE', null)
      try {
        const res = await ordersService.submitPayment(orderId, data)
        commit('SET_MESSAGE', res.message || 'Payment submitted successfully')
        return res
      } catch (err) {
        commit('SET_ERROR', err || 'Failed to submit payment')
      } finally {
        commit('SET_LOADING', false)
      }
    }
}